import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem  } from 'react-bootstrap';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import Logo from '../Logo/Logo';
import { withRouter, Link, NavLink } from 'react-router-dom';
import './Header.css';

import { LOGOUT } from '../../ReduxStore/slices/authSlice';
import LoginModal from '../../../components/partials/LoginModal';
import { FaShoppingCart } from 'react-icons/fa';
import { IconContext } from "react-icons";
import { connect } from 'react-redux';



const Header = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const LogoutBtn = () => {
        return (
          <NavItem className="nav-buttons">
            <button className="btn btn-light" onClick={toggleModal}>Login</button>
          </NavItem>
        );
    }

    const UserDropdown = ({reduxLogout}) => {
        return (
          <UncontrolledDropdown nav>
            <DropdownToggle nav caret className="text-white">
              {props.username}
            </DropdownToggle>
            <DropdownMenu className="my-" right>
              <DropdownItem className="my-0 ml-0 pl-3">
                <NavLink activeClassName="active" className="py-1 nav-link comp-nav mx-1" to={"/users/" + props.username}>Profile</NavLink>
              </DropdownItem>
              <DropdownItem className="my-0 ml-0 pl-3" divider />
              <DropdownItem className="my-0 ml-0 pl-3">
                <Link activeClassName="active" className="py-1 nav-link comp-nav mx-1" onClick={reduxLogout}>Logout</Link>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      }

    const NavBtn = () => {
        return (props.isAuthenticated ? <UserDropdown reduxLogout={props.reduxLogout} /> : <LogoutBtn />);
    }

    let cartItems = null;
    if (props.cartItems) {
        cartItems = <span className='CartItems'>{props.totalItems}</span>;
    }

    // console.log(props.location.pathname.slice(7, 15));
    return (
        <Navbar sticky ='top' className="Header px-5" variant="dark" bg="dark" expand="lg">
            <Navbar.Brand className="pl-5 Header_Logo" href="/"><Logo /></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="Header_NavCollapse" id="basic-navbar-nav">
                <Nav className="mr-auto Links">
                    <a href="/">
                        <span className={"NavLinks " + (props.location.pathname === '/' ? 'active' : '')}>Home</span>
                    </a>
                    <a href="/store">
                        <span className={"NavLinks " + (props.location.pathname === '/store' || props.location.pathname.slice(7, 15) === 'category' ? 'active' : '')}>Store</span>
                    </a>
                    <a href="/store/orders">
                        <span className={"NavLinks " + (props.location.pathname === '/store/orders' ? 'active' : '')}>Orders</span>
                    </a>
                </Nav>
                <Nav className="Header_CartIcon">
                    
                    <div className="mr-md-3 d-flex align-items-center">
                        <NavBtn />
                    </div>
                    
                    <Nav.Link className={"CartIcon " + (props.location.pathname === '/store/cart' ? 'active' : '')} href="/store/cart">
                    <IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                        <div className="d-flex justify-content-center mt-2 mt-md-2 pb-2">
                            <FaShoppingCart />
                        </div>
                    </IconContext.Provider>
                        { cartItems }
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
            <LoginModal toggleModal={toggleModal} isModalOpen={isModalOpen} />
        </Navbar>  
    )
}

const mapStateToProps = state => {
    return {
        cartItems: state.cart.cartProducts,
        totalItems: state.cart.totalItems,
        username: state.auth.username,
        isAuthenticated: state.auth.isAuthenticated
    }
}

const mapDispatchToProps = dispatch => {
    return {
        reduxLogout: () => dispatch(LOGOUT())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
